import * as React from 'react';
import { connect } from 'react-redux';
import { handleNextStep, setQuoteData } from '../../../../actions/salesActions';
import { PRODUCT_HOME_CONTENT } from '../../../../constants/constants';
import './InsuranceHistory.css';

class InsuranceHistory extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            currentlyInsured: this.props.sales.currentlyInsured,
        };

        this.handleHasInsurance = this.handleHasInsurance.bind(this);
    }

    handleHasInsurance(hasInsurance) {
        this.props.dispatchAction(setQuoteData({ currentlyInsured: hasInsurance }));
        this.props.dispatchAction(handleNextStep());
    }

    public render() {
        return (
            <div className="container">
                {this.props.sales.addProduct === PRODUCT_HOME_CONTENT &&
                    <div className="mt-4 text-center">
                        Do you currently have insurance for your home contents?
                    </div> || <div className="mt-4 text-center">
                        Do you currently have insurance for your buildings?
                    </div>
                }

                <div className="row">
                    <div className="col-md-6 text-right mt-4">
                        <button type="button" className={"btn" + ((this.state.currentlyInsured !== undefined && !this.state.currentlyInsured) ? " btn-solid-red" : " btn-outline-red ") + " btnNavigate"} onClick={() => this.handleHasInsurance(false)}>No, I don’t</button>
                    </div>

                    <div className="col-md-6 text-left mt-4">
                        <button type="button" className={"btn" + ((this.state.currentlyInsured !== undefined && this.state.currentlyInsured) ? " btn-solid-red" : " btn-outline-red ") + " btnNavigate"} onClick={() => this.handleHasInsurance(true)}>Yes, I do</button>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        sales: state.sales
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(InsuranceHistory);